import { makeStyles } from "@material-ui/core"

export default makeStyles(() => ({
    root: {
        bottom: 0,
        background: "#fff",
        position: "inline",
        /* negative value of footer height */
        clear: "both",
        /* Custom styling */
        marginLeft: 45 + 24,
        marginRight: 45 + 24
    },
    capitalized: {
        textTransform: "uppercase"
    }
}))
